/** @param {object | null | undefined} appConfig Redux `state.config.appConfig` */
export function isSweepstakesApplication(appConfig) {
  return appConfig?.app_currency_config?.application_type === "sweepstakes";
}
